// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3nqU3","buttons":"PendingPaymentAlert_buttons__1BjCU"};